import { render } from "./ScrollGallery.vue?vue&type=template&id=4f61f41a&scoped=true"
import script from "./ScrollGallery.vue?vue&type=script&lang=js"
export * from "./ScrollGallery.vue?vue&type=script&lang=js"

import "./ScrollGallery.vue?vue&type=style&index=0&id=4f61f41a&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f61f41a"]])

export default __exports__